// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator approvals`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import features from 'modules/core/store/collections/features'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import teams from 'modules/teams/store/collections/teams'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [employees, {}] /* Referenced by 14 cases in this module */,
    [features, {}] /* Referenced by 13 cases in this module */,
    [teams, {}] /* Referenced by 24 cases in this module */,
    [users, {}] /* Referenced by 19 cases in this module */,
  ] /* Generated file 👉 artifacts/approvals-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
